// import { useParams } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { hostName } from "../../config/config";
import { useDispatch } from "react-redux";
import { updateUserName } from "../../store/slices/UserSlice";

import Header from "../common/Header";
import SidebarIcons from "../common/SidebarIcons";
import Sidebar from "../common/Sidebar";
import Toaster from "../common/Toaster";
import PhoneNumber from "../common/PhoneNumber";
import ConfirmationPopup from "../common/ConfirmationPopup";
import ChangePassword from "../common/ChangePassword";

import useGetClientId from "../../hooks/useGetClientId";
import useGetCity from "../../hooks/useGetCity";
import http from "../../api/server";
import {
  GET_USER_PROFILEDETAILS,
  UPDATE_USER_PROFILE_DETAILS,
  UPDATE_MARKETING_PREFERENCES,
} from "../../api/apiPath";
import imageCompression from "browser-image-compression";

import { MARKETING_CONSTANT } from "../common/constant";

import uploadIcon from "../../assets/img/uploadIcon.png";

const FORMDATA = {
  firstName: "",
  lastName: "",
  emailAddress: "",
  contact1: "",
  countryCode1: "",
  dialCode1: "",
  city: "",
  cityId: "",
  role: "",
};

const UserProfile = () => {
  //   const { clientNameParam } = useParams();
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch();
   const [hideSidebar, setHideSidebar] = useState(false);
  const [clientLogo, setClientLogo] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [errors, setErrors] = useState(FORMDATA);
  const [formData, setFormData] = useState(FORMDATA);
  const [resetData, setResetData] = useState(FORMDATA);
  const [marketingValues, setMarketingValues] = useState(MARKETING_CONSTANT);
  const [resetMarketingValues, setResetMarketingValues] =
    useState(MARKETING_CONSTANT);
  const [isDisabled, setIsDisabled] = useState(true);
  const [, setLoading] = useState(false);
  const [cityOptions, setCityOptions] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const clientObj = useGetClientId();
  const cityObj = useGetCity();

  useEffect(() => {
    setCityOptions(cityObj?.cityList);
  }, [cityObj.cityList, cityObj.loading]);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (!clientObj?.clientId || !userObj?.userId) return;

    const fetchProfileDetails = async () => {
      try {
        setLoading(true);

        const response = await http.get(GET_USER_PROFILEDETAILS, {
          params: {
            clientId: clientObj.clientId,
            userId: userObj.userId,
          },
        });

        if (response?.status === 200) {
          const data = response?.data;
          setClientLogo(data?.profileImage || "");
          setFormData((prev) => ({
            ...prev,
            firstName: data?.firstName,
            lastName: data?.lastName,
            emailAddress: data?.email,
            contact1: data?.phoneNumber,
            city: data?.city,
            cityId: data?.cityId,
            role: data?.designation,
          }));
          setResetData((prev) => ({
            ...prev,
            firstName: data?.firstName,
            lastName: data?.lastName,
            emailAddress: data?.email,
            contact1: data?.phoneNumber,
            city: data?.city,
            cityId: data?.cityId,
            role: data?.designation,
          }));
          if(data?.marketingPreferences != null){

            const marketingPrefs = JSON.parse(data?.marketingPreferences);
  
            const titleToKey = {
              "Email Marketing": "Email",
              "SMS Notifications": "SMS",
              "Newsletter Subscription": "Newsletter",
              "Product Updates & Feature Releases": "Product",
              "Special Offers & Discounts": "Special",
            };
            setMarketingValues((prev) =>
              prev.map((item) => {
                const key = titleToKey[item.title]; // <-- no 'as keyof' in .jsx
                const checked = key ? Boolean(marketingPrefs[key]) : false;
                return { ...item, isChecked: checked };
              })
            );
            setResetMarketingValues((prev) =>
              prev.map((item) => {
                const key = titleToKey[item.title]; // <-- no 'as keyof' in .jsx
                const checked = key ? Boolean(marketingPrefs[key]) : false;
                return { ...item, isChecked: checked };
              })
            );
          }
        }
      } catch (err) {
        console.error("Error fetching profile details:", err);
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString:
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchProfileDetails();
  }, [clientObj?.clientId, userObj?.userId]);

  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  const fileInputRef = useRef(null);
  const phoneRef = useRef({});

  const handleClick = () => {
    fileInputRef.current.click();
  };
  // Handle profile image selection and preview.
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString:
            "File size exceeds 4MB limit. Please choose a smaller file.",
        });
        e.target.value = null; // Clear the input
        return;
      } else {
        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));
      }
    }
  };

  // Toggle marketing preference selection.
  const handleCheckbox = (e) => {
    const { id, checked } = e.target;
    const market = marketingValues;

    const newmarket = market.map((item) =>
      item.id.toString() == id ? { ...item, isChecked: checked } : item
    );

    setMarketingValues(newmarket);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = formData;
    updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : prevErrors[name],
    }));
  };

  // Update phone field and preserve dial/country codes.
  const handlePhoneChange = (value, field) => {
    const rawNumber = value?.mobileNumber
      .replace(value?.mobileDialCode, "")
      .replace(/^\+/, "");
    const formattedNumber = `+${value?.mobileDialCode}-${rawNumber}` || "";
    setFormData({
      ...formData,
      ["contact" + field]: formattedNumber,
      ["dialCode" + field]: value.mobileDialCode,
      ["countryCode" + field]: value.mobileCountryCode,
    });
  };

  const handleValidations = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "First Name is required";
    if (!formData.cityId) newErrors.city = "City is required";
    if (!formData.contact1) newErrors.contact1 = "Phone number is required";
    if (
      formData.contact1.replace(formData?.dialCode1, "").replace(/^\+|-/g, "") ===
      ""
    )
      newErrors.contact1 = "Phone number is required";
    return newErrors;
  };

  const baselineById = useMemo(
    () => new Map(resetMarketingValues.map((i) => [i.id, i.isChecked])),
    [resetMarketingValues]
  );

  const hasChanges = useMemo(
    () => marketingValues.some((i) => i.isChecked !== baselineById.get(i.id)),
    [marketingValues, baselineById]
  );

  // Validate, optionally compress image, and submit updated profile data.
  const handleUpdateProfile = async () => {
    setLoading(true);
    const validationErrors = handleValidations();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    } else {
      setErrors(FORMDATA);
      const params = new URLSearchParams();
      params.append("Id", userObj.userId);
      params.append("FirstName", formData.firstName);
      params.append("LastName", formData.lastName);
      params.append("FullName", `${formData.firstName} ${formData.lastName}`);
      params.append("CityId", formData.cityId);
      params.append("PhoneNumber", formData.contact1);

      let compreedFile = null;
      if (logoFile) {
        const options = {
          maxSizeMB: 0.5, // Target size
          maxWidthOrHeight: 1024, // Optional resize
          useWebWorker: true,
          initialQuality: 0.7, // Start compression at 70%
        };
        const compressedFile = await imageCompression(logoFile, options);
        compreedFile = new File([compressedFile], logoFile.name, {
          type: logoFile.type,
        });
      }

      if (hasChanges) {
        await handleUpdateMarketingPrefs();
      }

      const saveFormData = new FormData();
      saveFormData.append("ProfileImage", compreedFile);
      const queryString = params.toString();
      try {
        const response = await fetch(
          hostName + UPDATE_USER_PROFILE_DETAILS + `?${queryString}`,
          {
            method: "PUT",
            body: saveFormData,
            headers: {
              Authorization: "Bearer " + userObj?.token,
              ContentType: "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
           const newFullName = `${formData.firstName} ${formData.lastName}`;
          dispatch(updateUserName(newFullName));

          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Profile updated successfully",
          });
        } else {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in updating profile, please try again",
          });
        }
      } catch (err) {
        console.error("Update error:", err);

        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "Error adding details, please try again.",
        });
      } finally {
        setLoading(false);
        setIsDisabled(true);
      }
    }
  };

  const handleUpdateMarketingPrefs = async () => {
    const marketValues = {
      Email: marketingValues[0].isChecked,
      SMS: marketingValues[1].isChecked,
      Newsletter: marketingValues[2].isChecked,
      Product: marketingValues[3].isChecked,
      Special: marketingValues[4].isChecked,
    };

    const payload = {
      userId: userObj.userId,
      email: userObj.userEmail,
      marketingPreferences: JSON.stringify(marketValues),
    };

    try {
      const response = await http.post(UPDATE_MARKETING_PREFERENCES, payload);

      if (response.status === 200) {
        return await response.json();
      } else {
        console.error("Error updating marketing preferences");
        return null;
      }
    } catch (err) {
      console.error("Error updating marketing preferences:", err);
      return null;
    }
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText={showConfirmationPopup.headingText}
        infoText={showConfirmationPopup.infoText}
        cancelText={showConfirmationPopup.cancelText}
        submitText={showConfirmationPopup.submittext}
        onCancel={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
        }}
        onSubmit={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
          handleUpdateProfile();
        }}
      />
      {showPasswordModal && (
        <ChangePassword
          onCancel={() => setShowPasswordModal(false)}
          onFailure={(message) =>
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: message,
            })
          }
          onSuccess={() =>
            setToastData({
              toastShow: true,
              toastType: "success",
              toastString: "Password changed successfully",
            })
          }
        />
      )}
      {userObj && (
        <div className="dashboard_body_main">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}
          <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
            <div className="dashboard_header">
              <h2 className="mb-0">User Profile</h2>
              <div className="d-flex flex-row justify-content-between">
                <p className="header-description">View or edit user profile</p>
              </div>
            </div>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <h3 className="resident-card-header">Profile Information</h3>
              <div className="upload-section mt-2">
                <div className="upload-box-profile" onClick={handleClick}>
                  {/* <div className="upload-content"> */}
                    {logoPreview ? (
                      <>
                        <img
                          src={logoPreview}
                          alt="Uploaded Logo"
                          className="upload-box-image"
                        />
                      </>
                    ) : (
                      <img
                        // style={{ height: "100px", width: "100px" }}
                        className={
                          clientLogo ? "upload-box-image" : "upload-box-icon"
                        }
                        src={
                          clientLogo
                            ? ImageProxyBaseUrl + encodeURIComponent(clientLogo)
                            : uploadIcon
                        }
                        alt="upload"
                      />
                    )}
                  {/* </div> */}
                </div>
                <div className="upload-info ms-3">
                  <p className="upload-text">
                    <span className="browse-link" onClick={handleClick}>
                      Upload
                    </span>{" "}
                    a profile photo. Recomended size: 400x400px
                  </p>
                  <small className="upload-hint">PNG, JPG up to 4MB</small>
                </div>
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  max={4}
                  disabled={isDisabled}
                />
              </div>
              <div className="card-body-section mt-3">
                <div className="form-group">
                  <label htmlFor="firstName">
                    First Name <span className="label-star">*</span>
                  </label>
                  <input
                    className={errors.firstName ? "input-error" : ""}
                    name="firstName"
                    id="firstName"
                    placeholder="Enter first name"
                    aria-label="Floating label select example"
                    value={formData.firstName}
                    disabled={isDisabled}
                    onChange={(e) => {
                      handleFormChange(e);
                    }}
                  ></input>
                  {errors.firstName && (
                    <span className="formError">{errors.firstName}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    className={errors.lastName ? "input-error" : ""}
                    name="lastName"
                    id="lastName"
                    placeholder="Enter last name"
                    aria-label="Floating label select example"
                    value={formData.lastName}
                    disabled={isDisabled}
                    onChange={(e) => {
                      handleFormChange(e);
                    }}
                  ></input>
                  {errors.lastName && (
                    <span className="formError">{errors.lastName}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="emailAddress">
                    Email Address <span className="label-star">*</span>
                  </label>
                  <input
                    className={errors.emailAddress ? "input-error" : ""}
                    name="emailAddress"
                    id="emailAddress"
                    placeholder="Enter email address"
                    aria-label="Floating label select example"
                    value={formData.emailAddress}
                    disabled
                    onChange={(e) => {
                      handleFormChange(e);
                    }}
                  ></input>
                  {errors.emailAddress && (
                    <span className="formError">{errors.emailAddress}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    Phone Number <span className="label-star">*</span>
                  </label>
                  <PhoneNumber
                    setPhoneNumber={(e) => {
                      handlePhoneChange(e, "1");
                    }}
                    phoneNumber={{
                      mobileNumber: formData.contact1,
                      mobileCountryCode: formData.countryCode1,
                      mobileDialCode: formData.dialCode1,
                    }}
                    inputRef={(el) => (phoneRef.current["contact1"] = el)}
                    disabled={isDisabled}
                  />
                  {errors.contact1 && (
                    <span className="formError">{errors.contact1}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="city">
                    City <span className="label-star">*</span>
                  </label>
                  <select
                    className={errors.city ? "input-error" : ""}
                    name="cityId"
                    id="city"
                    placeholder="Enter city"
                    aria-label="Floating label select example"
                    value={formData.cityId}
                    disabled={isDisabled}
                    onChange={(e) => {
                      handleFormChange(e);
                    }}
                  >
                    <option value="">Select City</option>
                    {cityOptions?.map((data) => (
                      <option key={data?.cityId} value={data?.cityId}>
                        {data.cityName}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <span className="formError">{errors.city}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="role">
                    Role <span className="label-star">*</span>
                  </label>
                  <select
                    className={errors.role ? "input-error" : ""}
                    name="role"
                    id="role"
                    placeholder="Enter role"
                    aria-label="Floating label select example"
                    value={formData.role}
                    disabled={true}
                    onChange={(e) => {
                      handleFormChange(e);
                    }}
                  >
                    <option selected value="0">
                      {formData.role}
                    </option>
                    <option value="Fire Door Survey">Fire Door Survey</option>
                  </select>
                  {errors.role && (
                    <span className="formError">{errors.role}</span>
                  )}
                </div>
              </div>
            </div>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <div>
                <h3 className="resident-card-header mb-1">
                  Marketing and Promotional Offers
                </h3>
                <p className="resident-card-subheader">
                  Choose how you&apos;d like to receive updates and promotional
                  offers from us.
                </p>
              </div>
              <div className="d-flex flex-column gap-3">
                {marketingValues?.length > 0 &&
                  marketingValues?.map((item) => {
                    return (
                      <div className="marketing-box" key={item.id}>
                        <input
                          className="custom-checkbox mt-1"
                          type="checkbox"
                          id={item.id}
                          name={item.id}
                          disabled={isDisabled}
                          checked={item?.isChecked}
                          onChange={(e) => handleCheckbox(e)}
                        />
                        <div>
                          <p className="marketing-header mb-0">{item.title}</p>
                          <p className="marketing-description mb-0">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="privacy-notice-box mt-2">
                <p
                  className="mb-0"
                  style={{
                    fontWeight: "600",
                    fontSize: "0.7rem",
                    color: " #171717",
                  }}
                >
                  Privacy Notice:&nbsp;{" "}
                </p>
                <p
                  className="mb-0"
                  style={{
                    fontWeight: "300",
                    fontSize: "0.7rem",
                    color: " #737373",
                  }}
                >
                  We respect your privacy. You can unsubscribe from any of these
                  communications at any time. Your data will be handled in
                  accordance with our Privacy Policy and GDPR regulations.
                </p>
              </div>
            </div>
            <div className="button-container">
              {isDisabled && (
                <button
                  type="submit"
                  className="btn-primary col-sm-5 col-md-2"
                  onClick={() => setShowPasswordModal(true)}
                >
                  Change Password
                </button>
              )}
              {isDisabled && (
                <button
                  type="submit"
                  className="btn-secondary col-sm-5 col-md-2"
                  onClick={() => setIsDisabled(false)}
                >
                  Edit Profile
                </button>
              )}
              {!isDisabled && (
                <button
                  type="submit"
                  className="btn-primary col-sm-5 col-md-2"
                  onClick={() =>
                    setShowConfirmationPopup({
                      ...showConfirmationPopup,
                      show: true,
                      headingText: "Update Profile Details",
                      infoText: "Please confirm to update the profile details.",
                      cancelText: "Cancel",
                      submittext: "Save",
                    })
                  }
                >
                  Update Profile
                </button>
              )}
              {!isDisabled && (
                <button
                  type="submit"
                  className="btn-secondary col-sm-5 col-md-2"
                  onClick={() => {
                    setIsDisabled(true);
                    setFormData({ ...resetData });
                    setMarketingValues([...resetMarketingValues]);
                     window.location.reload();
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserProfile;
